import { ProductViewBase } from '@amzn/coral_com-amazon-sssapinterface-model-structures-credits';
import { OFFER_TIER } from '@amzn/sss-website-theme';

/**
 * Determines whether the original (base) price should be displayed alongside
 * the discounted signatory price.
 */
export const shouldShowOriginalPrice = (product: ProductViewBase): boolean =>
  product.productMatchedOfferTier != null &&
  product.productMatchedOfferTier !== OFFER_TIER.BASE &&
  product.productBaseOfferPrice != null &&
  product.productMatchedOfferPrice != null &&
  product.productBaseOfferPrice > product.productMatchedOfferPrice;

/**
 * Formats a product price to always show 2 decimal places.
 * Returns an empty string if the price is undefined.
 */
export const formatProductPrice = (price: number | undefined): string => price?.toFixed(2) ?? '';
